var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDouwnload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 24px  / menu / modules",
    clipPath: "url(#clip0_8012_32998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.23267 15.1017C9.20868 16.0783 10.7916 16.0788 11.7682 15.1028C11.7686 15.1024 11.769 15.1021 11.7693 15.1017L14.4452 12.4259C14.7538 12.0845 14.7273 11.5575 14.3859 11.2488C14.0681 10.9614 13.5841 10.962 13.2668 11.25L10.8285 13.6892L10.8343 0.833359C10.8343 0.373086 10.4612 0 10.001 0C9.54075 0 9.16767 0.373086 9.16767 0.83332L9.16017 13.6733L6.73517 11.25C6.40954 10.9246 5.88181 10.9248 5.55642 11.2504C5.23103 11.5761 5.23122 12.1038 5.55685 12.4292L8.23267 15.1017Z",
    fill: "#1B4458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1667 13.334C18.7064 13.334 18.3334 13.7071 18.3334 14.1673V17.5007C18.3334 17.9609 17.9603 18.334 17.5 18.334H2.5C2.03977 18.334 1.66668 17.9609 1.66668 17.5007V14.1673C1.66668 13.7071 1.29359 13.334 0.833359 13.334C0.373086 13.334 0 13.7071 0 14.1673V17.5007C0 18.8814 1.1193 20.0007 2.5 20.0007H17.5C18.8807 20.0007 20 18.8814 20 17.5007V14.1673C20 13.7071 19.6269 13.334 19.1667 13.334Z",
    fill: "#1B4458"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8012_32998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouwnload);
export default __webpack_public_path__ + "static/media/douwnload.aab49cefafdeae3e28824f6865e9fae6.svg";
export { ForwardRef as ReactComponent };